import React from 'react';
import ReactDOM from 'react-dom/client';

import AuthContainer from './containers/AuthContainer';

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthContainer useStatus appBase='/usis/advice/fps' />,
)